import Vue from 'vue';
import VueRouter from "vue-router";

Vue.use(VueRouter);

const HomePage = () => import("@/components/HomePage");
const Newss = () => import("@/views/lanmu1/news.vue");
const content = () => import("@/views/content/content.vue");
const content2 = () => import("@/views/content/content-test.vue");
const departmentCenter = () => import("@/views/content/departmentCenter.vue");
const shipcontent = () => import("@/views/content/shipcontent.vue");
const search = () => import("@/views/other/searchPage.vue");
const about = () => import("@/views/aboutlm/about.vue");
const leadlist = () => import("@/views/aboutlm/leadlist.vue");
const leaderDetails = () => import("@/views/content/leaderDetails.vue");
const organization = () => import("@/views/aboutlm/organization.vue");
const shebei = () => import("@/views/aboutlm/shebei.vue");
const information = () => import("@/views/aboutlm/information.vue");
const news = () => import("@/views/new/news.vue");
const notice = () => import("@/views/new/notice.vue");
const videonew = () => import("@/views/new/videonew.vue");
const partylist1 = () => import("@/views/partylm/partylist1.vue");
const partylist2 = () => import("@/views/partylm/partylist2.vue");
const medicallist = () => import("@/views/other/medicallist.vue");
const subjectlist = () => import("@/views/subject/subjectlist.vue");
const expertlist = () => import("@/views/subject/expertlist.vue");
const expertDetail = () => import("@/views/subject/expertDetail.vue");
const technologylist = () => import("@/views/subject/technologylist.vue");
const carelist = () => import("@/views/other/carelist.vue");
const healthylist = () => import("@/views/other/healthylist.vue");
const servelist = () => import("@/views/other/servelist.vue");
const teachinglist = () => import("@/views/keyanzu/teachinglist.vue");
const peixunlist = () => import("@/views/keyanzu/peixunlist.vue");
const lxaddress = () => import("@/views/connect/lxaddress.vue");
const message = () => import("@/views/connect/message.vue");
const area=()=>import("@/views/area/index.vue");
const advancedStudyApplication=()=>import("@/views/keyanzu/advancedStudyApplication.vue");
const routes = [{
    path: '/Index',
    component: HomePage,
    name: '首页'
  },

  {
    path: '/lanmu22',
    component: Newss,
    name: '要闻动态'
  },
  {
    path: '/information/:id',
    component: information,
    name: '信息公开'
  },
  {
    path: '/content/:id',
    component: content,
    name: '内容页'
  },
  {
    path: '/content2/:id',
    component: content2,
    name: '内容页2'
  },
  {
    path: '/departmentCenter/:id',
    component: departmentCenter,
    name: '科室介绍'
  },
  {
    path: '/advancedStudyApplication/:id',
    component:advancedStudyApplication,
    name: '进修申请'
  },
  {
    path: '/ship/:id',
    component: shipcontent,
    name: '视频播放页'
  },
  {
    path: '/leaderDetails/:id',
    component: leaderDetails,
    name: '领导详情页'
  },
  {
    path: '/other/:title',
    component: search,
    name: '搜索结果页'
  },
  {
    path: '/aboutlm/:id',
    component: about,
    name: '医院概况'
  },
  {
    path: '/aboutlm2/:id',
    component: leadlist,
    name: '领导班子'
  },
  {
    path: '/zuzhijigou/:id',
    component: organization,
    name: '组织机构'
  },
  {
    path: '/shebei/:id',
    component: shebei,
    name: '环境设备'
  },
  {
    path: '/news/:id',
    component: news,
    name: '医院动态'
  },
  {
    path: '/newnotice/:id',
    component: notice,
    name: '通知公告'
  },
  {
    path: '/newvideo/:id',
    component: videonew,
    name: '新闻视频'
  },
  {
    path: '/dflz/:id',
    component: partylist1,
    name: '党风廉政'
  },
  {
    path: '/lzjsh/:id',
    component: partylist2,
    name: '廉政建设'
  },
  {
    path: '/ylgl/:id',
    component: medicallist,
    name: '医疗管理'
  },
  {
    path: '/xkjsh/:id',
    component: subjectlist,
    name: '学科建设'
  },
  {
    path: '/zjabout/:id',
    component: expertlist,
    name: '专家介绍'
  },
  {
    path: '/expertList/:id/:name',
    component: expertDetail,
    name: '专家列表'
  },
  {
    path: '/jsyshi/:id',
    component: technologylist,
    name: '技术优势'
  },
  {
    path: '/hltd/:id',
    component: carelist,
    name: '护理天地'
  },
  {
    path: '/healthypage/:id',
    component: healthylist,
    name: '健康教育'
  },
  {
    path: '/servepage/:id',
    component: servelist,
    name: '服务患者'
  },
  {
    path: '/kyjx/:id',
    component: teachinglist,
    name: '科研教学'
  },
  {
    path: '/gfhpx/:id',
    component: peixunlist,
    name: '规范化培训'
  },
  {
    path: '/contact/:id',
    component: lxaddress,
    name: '联系我们'
  },
  {
    path: '/message/:id',
    component: message,
    name: '在线留言'
  },
    {
    path: '/gxarea',
    component: area,
    name: '高新院区'
  },
  {
    path: '*',
    redirect: '/Index'
  },
  
];

const router = new VueRouter({
  routes,
  //配置滚动行为，跳转到新的路由界面滚动条的位置
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
});

export default router;